import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 74 74"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#525DDC",
  d: "M1.233 0 0 1.233v16.034l1.057 1.057 34.886-5.815L37 13.567v11.1l35.52-5.92 1.48-1.48V1.233L72.767 0H1.233zm.247 30.587L0 32.067v9.866l1.057 1.057L37 37V24.667l-35.52 5.92zM37 37v12.334l35.52-5.92 1.48-1.48v-9.867l-1.057-1.057L37 37zM1.48 55.253 0 56.733v16.034L1.233 74h71.534L74 72.767V56.733l-1.057-1.057-34.886 5.815L37 60.434v-11.1l-35.52 5.92z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render() { return h(NuxtIcon, {icon: {render}}) } }